import {PackingTimeComponent} from "./packing-time.component";

export default PackingTimeComponent
